import { Injectable } from '@angular/core';

import { formatISO } from 'date-fns';
import { RootState } from 'projects/semeris/src/store/root-state.model';

import { LogLevel } from '../../models/log-configuration.model';
import { LogProviderService } from '../log-provider.service';

@Injectable()
export class ConsoleLoggerService extends LogProviderService {
  public readonly anonymus = 'anonymus';
  public userPrefix: string | null = null;

  private readonly disabled = true;

  public setUser(identifier: string, email: string): void {
    this.userPrefix = email;
  }
  public navigation(path: string, level: LogLevel) {
    if (!this.disabled) {
      console.info(
        `${this.getTimestamp()} - ${this.userPrefix || this.anonymus}: navigated ${path}`
      );
    }
  }
  public action<T>(actionType: string, payload: T) {
    if (!this.disabled) {
      console.info(`${this.getTimestamp()} - ${this.userPrefix || this.anonymus}: ${actionType}`);
    }
  }
  public attachStore(store: RootState) {}
  public verbose(message: any, optionalParameters?: any[]): void {
    console.debug(`${this.getTimestamp()} - ${this.userPrefix || this.anonymus}: ${message}`);
  }
  public info(message: any, optionalParameters?: any[]): void {
    if (!this.disabled) {
      console.info(`${this.getTimestamp()} - ${this.userPrefix || this.anonymus}: ${message}`);
    }
  }
  public warn(message: any, optionalParameters?: any[]): void {
    console.warn(`${this.getTimestamp()} - ${this.userPrefix || this.anonymus}: ${message}`);
  }
  public error(message: any, customData?: any): void {
    console.error(`${this.getTimestamp()} - ${this.userPrefix || this.anonymus}: ${message}`);
    if (message instanceof Error) {
      console.error(message);
    }
  }

  private getTimestamp(): string {
    return formatISO(Date.now());
  }
}
